import React from 'react'

const PolicyLink = ({ children, ...rest }) => (
  <a target="_blank" rel="noreferrer" className="text-current" {...rest}>
    {children}
  </a>
)

export default PolicyLink
